import CustomTab from "@/components/CustomTab";
import React, { useRef } from "react";
import Head from "next/head";
import AnimatedTitleHeader from "@/components/TitleHeader/AnimatedTitleHeader";
import NoIndexMeta from "@/components/Common/NoIndexMeta";
import MetaTags from "@/components/seo/meta-tags";
import Link from "next/link";

const TermsAndConditions = () => {
  const KeyPoints = [
    {
      key: "1",
      text: "Summary of key points",
    },
    {
      key: "2",
      text: "What information do we have to collect?",
    },
    {
      key: "3",
      text: "How do we process your information?",
    },
    {
      key: "4",
      text: "What information do we have to collect?",
    },
    {
      key: "5",
      text: "What information do we have to collect?",
    },
  ];

  const Content = [
    {
      key: "1",
      data: [
        {
          heading: "Last updated September 19, 2022",
          text: (
            <div>
              <p className="pb-4">
                {" "}
                This is Terms of Service notice for Bizinbiz Technologies Pvt
                Ltd (doing business as Elchemy). Please read these Terms of Use
                (“Terms”, “Terms of Use”) carefully before using the
                www.elchemy.com/ website (the “Service”) operated by Bizinbiz
                Technologies Pvt Ltd (doing business as Elchemy) (“
                Elchemy”,“us”, “we”, or “our”).{" "}
              </p>
              <p className="pb-4">
                Your access to and use of the Service is conditioned on your
                acceptance of and compliance with these Terms. These Terms apply
                to all visitors, users and others who access or use the Service.
                By accessing or using the Service you agree to be bound by these
                Terms. If you disagree with any part of the terms then you may
                not access the Service
              </p>
            </div>
          ),
        },
        {
          key: "2",
          heading: "INTELLECTUAL PROPERTY",
          text: (
            <div>
              The Service and its original content, features and functionality
              are and will remain the exclusive property of Bizinbiz
              Technologies Pvt Ltd (doing business as Elchemy) and its
              licensors.
            </div>
          ),
        },
        {
          key: "3",
          heading: "LINKS TO OTHER WEBSITES",
          text: (
            <div>
              <p className="pb-4">
                {" "}
                Our Service may contain links to third-party websites or
                services that are not owned or controlled by Bizinbiz
                Technologies Pvt Ltd (doing business as Elchemy).
              </p>{" "}
              <p className="pb-4">
                {" "}
                Bizinbiz Technologies Pvt Ltd (doing business as Elchemy)has no
                control over, and assumes no responsibility for, the content,
                privacy policies, or practices of any third party web sites or
                services. You further acknowledge and agree Bizinbiz
                Technologies Pvt Ltd (doing business as Elchemy)shall not be
                responsible or liable, directly or indirectly, for any damage or
                loss caused or alleged to be caused by or in connection with use
                of or reliance on any such content, goods or services available
                on or through any such web sites or services.{" "}
              </p>{" "}
              <p className="pb-4">
                {" "}
                We strongly advise you to read the terms and conditions and
                privacy policies of any third-party web sites or services that
                you visit.
              </p>
            </div>
          ),
        },
        {
          key: "4",
          heading: "TERMINATION",
          text: (
            <div>
              <p className="pb-4">
                {" "}
                We may terminate or suspend access to our Service immediately,
                without prior notice or liability, for any reason whatsoever,
                including without limitation if you breach the Terms.
              </p>{" "}
              <p className="pb-4">
                All provisions of the Terms which by their nature should survive
                termination shall survive termination, including, without
                limitation, ownership provisions, warranty disclaimers,
                indemnity and limitations of liability.
              </p>{" "}
            </div>
          ),
        },
        {
          key: "5",
          heading: "DISCLAIMER",
          text: (
            <div>
              <p className="pb-4">
                Your use of the Service is at your sole risk. The Service is
                provided on an “AS IS” and “AS AVAILABLE” basis. The Service is
                provided without warranties of any kind, whether express or
                implied, including, but not limited to, implied warranties of
                merchantability, fitness for a particular purpose,
                non-infringement or course of performance.
              </p>
            </div>
          ),
        },
      ],
    },
  ];

  const parentRef = useRef(null);

  return (
    <>
      <MetaTags
        title="Terms and conditions"
        description="Terms and conditions"
      />

      <div className="pt-[10vh] sm:pt-[12vh]">
        <AnimatedTitleHeader
          text={"Terms and Conditions"}
          imgSrc={
            "https://storage.googleapis.com/elchemy-dev/1706608938_JV6I0G2.png"
          }
        />
        <div className="px-6 md:px-20 py-8">
          <p className="">
            <Link href={"/"} className="text-[0.85rem] text-[#808080]">
              Home
            </Link>{" "}
            <span className="px-1">/</span>{" "}
            <span className="font-medium text-[0.9rem]">Terms of service</span>
          </p>
          <div
            className="flex flex-col sm:flex-row justify-between w-full relative pt-[2rem] sm:pt-[3rem]"
            ref={parentRef}
          >
            {/* <div className="w-full sm:w-[75%] min-h-[80vh]">
          {getSelectedData(Content)?.map((data) => {
            return (
              <div>
                <p className=" text-[1rem] mb-6 font-medium">{data?.heading}</p>
                <p className="text-[0.9rem] mb-12 font-light text-[#666666]">
                  {data?.text}
                </p>
              </div>
            );
          })}
        </div> */}
            <div className="w-full sm:w-[75%] min-h-[80vh]">
              <div>
                <p className=" text-[1rem] mb-6 font-medium">
                  Last updated 5th July 2024
                </p>
                <p className="text-[0.9rem] mb-12 font-light text-[#666666]">
                  The provisions of these terms and conditions (“Terms”) govern
                  the supply of products by you or the entity you represent (the
                  ‘’Partner’’) to BizinBiz Technologies Pvt Ltd ("Company”).
                  These Terms shall be read in conjunction with the general
                  terms and conditions at
                  https://www.elchemy.com/terms-and-conditions ("General Terms”)
                  and in the event of any conflict between the General Terms and
                  these Terms, the provisions of these Terms shall supersede and
                  prevail.
                </p>

                <p className=" text-[1rem] mb-6 font-medium">
                  The Company and the Partner are collectively referred to as
                  the “Parties” or individually as a “Party”, as the context may
                  require.
                </p>
                <p className=" text-[1rem] mb-6 font-medium">
                  IT IS HEREBY AGREED AS FOLLOWS:
                </p>
              </div>
              <div>
                <ol className="list-decimal">
                  <li>
                    <p className=" text-[1rem] mb-2 font-medium">Term</p>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      This Agreement shall be effective on and from the date of
                      registration of the Partner on the website of the Company,
                      i.e. https://next.elchemy.com (“Portal”), and shall remain
                      valid unless otherwise terminated earlier in accordance
                      with Clause 24 (“Termination and effects of termination”).
                    </p>
                  </li>
                  <li>
                    <p className=" text-[1rem] mb-2 font-medium">
                      Supply of Products
                    </p>
                    <ol className="list-decimal pl-5">
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          During the Term, the Partner shall supply products of
                          such nature, description of which shall be specified
                          in the relevant Purchase Orders (“Products”), to the
                          Company, and the Company shall purchase the Products
                          in accordance with the terms and conditions set forth
                          in this Agreement and the respective Purchase
                          Order(s).
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          The Partner shall, at the time of entering into this
                          Agreement, create a virtual account on the Portal. The
                          Partner shall have the right to access its virtual
                          account on the Portal from time to time, which shall
                          give the Partner access to the Purchase Order(s)
                          issued by the Company, order tracking, dispatch &
                          delivery timelines, packaging specifications, invoice
                          tracking, and such other relevant information/
                          documents (“Partner Dashboard”). Further, the Partner
                          shall provide relevant information/ upload documents
                          on the Partner Dashboard, as may be required from time
                          to time.
                        </p>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <p className=" text-[1rem] mb-2 font-medium">
                      Purchase Orders:
                    </p>
                    <ol className="list-decimal pl-5">
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          During the Term, the Company shall place orders (each
                          a “Purchase Order”) with the Partner for the supply of
                          Products. The Purchase Order shall contain details
                          with respect to the description and specifications of
                          the Products, including but not limited to the
                          delivery models, delivery locations, and the timelines
                          for delivery of the Products.
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          Each Purchase Order raised by the Company shall be
                          available for access by the Partner on the Partner
                          Dashboard.{" "}
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          Within two (2) working days from the date on which the
                          Company uploads the Purchase Order on the Partner
                          Dashboard, the Partner shall communicate:{" "}
                        </p>
                      </li>
                    </ol>
                    <ol className="list-decimal pl-5">
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          its acceptance of the Purchase Order, or
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          partial acceptance of the Purchase Order, subject to
                          variation in terms and/or contents thereof
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          rejection of the same on the Partner Dashboard.{" "}
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          A Purchase Order shall be deemed to be accepted by a
                          Partner only upon issuance of an explicit acceptance
                          in accordance with provisions of Clause 2.3(c) above
                          within the timelines prescribed therein.
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          If the Partner fails to communicate its acceptance in
                          terms of Clause 2.3 (c) above, the Purchase Order or
                          the modified Purchase Order, as the case may be, shall
                          be deemed to be rejected by the Partner, unless
                          otherwise notified by the Company on the Partner
                          Dashboard.
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          Either Party shall be entitled to request for a
                          variation in the Purchase Order no later than two (2)
                          days of the Purchase Order being accepted by the
                          Partner. In the event a Party requests for a variation
                          in the Purchase Order, the other Party shall
                          communicate the acceptance or rejection of such
                          request within two (2) working days of receipt of such
                          request. Provided that irrespective of placing of the
                          Purchase Order by the Company and acceptance thereof
                          by the Partner, the Company shall be entitled to
                          reject the invoices/ proforma invoices raised by the
                          Partner in terms of Clause 3.4 of this Agreement.
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          In case of rejection of the Purchase Order by the
                          Partner or, rejection of the modification to the
                          Purchase Order by the Company, as the case may be, in
                          accordance with the terms of this Agreement, the
                          particular Purchase Order shall stand cancelled, and
                          no rights and obligations in relation to the same
                          shall subsist in favour of either Party.
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          In the event of any conflict arising between the
                          provisions of this Agreement and the Purchase Orders,
                          the provisions of the Agreement shall prevail.
                        </p>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <p className=" text-[1rem] mb-2 font-medium">
                      Delivery Timelines and Lead Time:
                    </p>
                    <ol className="list-decimal pl-5">
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          The Partner hereby acknowledges that time is of
                          essence in the performance of the obligations of the
                          Partner under this Agreement and the Purchase
                          Order(s). The Partner shall adhere to all the
                          timelines as provided in the Purchase Order, including
                          but not limited to the lead time as set out in the
                          Purchase Order/ on the Partner Dashboard.
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          The Partner agrees not to ship any Products without
                          the acceptance of the invoice by the Company. The
                          Partner further agrees that the Company shall have the
                          right to reject any invoice raised by it at its sole
                          discretion.
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          In the event of a delay in delivery of the Products,
                          the Company reserves the right to (i) cancel the
                          relevant Purchase Order, in which case the Partner
                          shall be liable to compensate the Company for any
                          costs which may be incurred by the Company on account
                          of such cancellation; or (ii) accept the relevant
                          Purchase Order, and impose penalties on the Partner,
                          as more particularly set forth in the Purchase Order/
                          on the Partner Dashboard.
                        </p>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <p className=" text-[1rem] mb-2 font-medium">
                      Packaging Requirements:
                    </p>
                    <ol className="list-decimal pl-5">
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          All Products to be delivered by the Partner, shall be
                          appropriately packaged for delivery to the
                          location(s)/ address(es) as set out in the relevant
                          Purchase Order (“Delivery Destination”), in accordance
                          with the instructions provided by the Company.
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          The Partner shall ensure that the packaging and labels
                          for supply of the Products under this Agreement are in
                          accordance with the specifications provided by the
                          Company.
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          In the event of any damage caused to the Products
                          during transportation on account of inadequate/
                          inappropriate packaging, the Partner shall be
                          responsible for making good such damage and any
                          ancillary costs associated therewith.
                        </p>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <p className=" text-[1rem] mb-2 font-medium">
                      Quality Check:
                    </p>
                    <ol className="list-decimal pl-5">
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          Upon delivery of the Products at the Delivery
                          Destination, the Company shall arrange for an
                          inspection of the Products, either themselves or
                          through a third party appointed by the Company, to
                          assess conformance of the Products with the
                          specifications, and/or shortages, and/or defects
                          communicated by the Company to the Partner in the
                          relevant Purchase Order. In case of inspection by any
                          third-party, the ownership of the Products shall be
                          deemed to pass from the Partner to the Company, only
                          upon the Company receiving written confirmation of
                          acceptance of the Products by such third-party. Until
                          the Partner receives written confirmation of
                          acceptance of the Products from the Company, the title
                          of the Products shall continue to remain with the
                          Partner.
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          The Parties agree that upon delivery of the Products,
                          the Partner shall provide to the Company, a duly
                          executed declaration stating that the Partner has
                          complied with all the specifications as set forth in
                          the relevant Purchase Order.
                        </p>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <p className=" text-[1rem] mb-2 font-medium">
                      Rejection and Returns:{" "}
                    </p>
                    <ol className="list-decimal pl-5">
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          In case of any defect or fault in the Products,
                          including but not limited to any deviation from the
                          specifications, supplied by the Partner to the
                          Company, the Company shall have the right to return
                          each such defective/ faulty Product to the Partner.
                          The Company shall notify the Partner of such defect or
                          fault, in writing. Upon, receipt of such notification,
                          the Partner shall arrange for a (i) replacement, at
                          the sole cost of the Partner; or (ii) refund of the
                          Product, as notified by the Company. The replacement/
                          refund of the defective/ faulty Products shall be
                          initiated by the Partner within a period of five (5)
                          working days from the date of receipt of notification
                          from the Company.
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          The refund related costs and expenses of the Products
                          may be provided to the Company in the following
                          manner, at the discretion of the Company:
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          In the event that the Partner is obliged to refund the
                          Company for the defective/ faulty Product in
                          accordance with Clause 13 (a), the Partner shall
                          compensate the Company with the cost of the Product,
                          including but not limited to any applicable taxes paid
                          and other expenses, if any.
                        </p>
                      </li>
                    </ol>
                    <ol className="list-decimal pl-5">
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          the total cost of the defective/ faulty Products
                          returned and other expenses incurred, if any, shall be
                          set off from the total cost of the Products accepted
                          by the Company; or
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          the total cost of the defective/ faulty Products
                          returned and other expenses incurred, if any, shall be
                          refunded to the Company; or
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          the Partner shall provide a credit note equal to the
                          total cost of the defective/ faulty Products returned
                          and other expenses, if any, to the Company.
                        </p>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <p className=" text-[1rem] mb-2 font-medium">
                      Passing of Title and Risk:{" "}
                    </p>
                    <ol className="list-decimal pl-5">
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          In the event that the Partner is engaged in the final
                          delivery of the Products to the Delivery Destination,
                          the title and risk to the Products shall pass from the
                          Partner to the Company, upon final delivery of the
                          Products to the Delivery Destination.
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          In the event that the Partner is not engaged in the
                          final delivery of the Products to the Delivery
                          Destination, the title and risk to the Products shall
                          pass from the Partner to the Company, upon the loading
                          of Products in the vehicles specified by the Company.
                        </p>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <p className=" text-[1rem] mb-2 font-medium">
                      Payment Terms.
                    </p>
                    <ol className="list-decimal pl-5">
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          The Company, under this Agreement, may make advance
                          payments to the Partner of such amounts as
                          communicated by the Company to the Partner. Such
                          advance payment shall be made upon issuance of PO
                          acceptance/ Invoice/proforma invoice by the Partner
                          and all amounts due under the advance payment shall be
                          liable to be adjusted against the amounts owed by
                          Elchemy to the Partner.
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          The Partner shall raise on the Company, an invoice
                          setting out the price for the Products, as agreed to
                          in the Purchase Order (“Product Price”) withinsuch
                          period as set out in the Purchase Order. The Partner
                          shall ensure that the consignee shares with the
                          Company original copies of Proof of Delivery, Goods
                          Receipt Note and all other required supporting
                          documents along with such invoice. The Partner shall
                          adjust the invoice amounts against the Advance
                          received from the Company (“Adjustment”). The Company
                          shall calculate such Adjustment and shall provide the
                          Partner details of invoice amount outstanding after
                          such Adjustment. In case the invoice amount is left
                          outstanding after Adjustment, the Company shall make
                          the payment of undisputed invoices raised by the
                          Partner within three 3 Working Days from the date of
                          receipt of original invoice ["Due Date”]. The payment
                          shall be made by the Company only if it finds the
                          invoice and all necessary the supporting documents
                          correct in all respects.
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          In case of return of the Products by the Company to
                          the Partner, due to any reason including but not
                          limited to return of the Product by any Customer of
                          the Company (‘’End Client(s)’’), deviation from
                          specifications, deviation in quantity, quality of the
                          Products as set out in POs, cancellation of POs by the
                          Company, the Partner shall forthwith return any
                          Advance money paid proportional to the Product Price
                          set out in the disputed Purchase Order.
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          In case of any delay in the return of Advance by the
                          Partner to the Company, the Company reserves the right
                          to charge an interest @ 2% per month on the advance
                          amount starting from 3rd day from which the advance so
                          paid.
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          Notwithstanding anything contained herein, the Company
                          shall reject the invoice in the event that (a) the
                          product price specified in the invoice is more than
                          the price agreed between the Parties in the Purchase
                          Order; or (b) the invoice raised by the Partner is
                          illegible; or (c) in case of delivery of Products
                          undertaken by the Partner, the proof of delivery is
                          not provided to the Company; and the Company shall not
                          be liable to pay the Product Price in accordance with
                          Clause 3.2.
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          It is agreed between the Parties, that notwithstanding
                          anything else contained herein, in cases of uploading
                          of invoices/proforma invoices pre-shipment, the
                          Company shall have the right to accept or reject the
                          order/invoice/proforma invoice within 7 (seven)
                          working days from the date of uploading the same on
                          the Portal. Only where the Company accepts the
                          invoice/proforma invoice, shall the Partner ship the
                          goods and Company become liable for payment as per the
                          terms of this Agreement. In case of rejection of the
                          invoice/ proforma invoice by the Company in terms of
                          this Clause, the Purchase Order or the modified
                          Purchase Order, as the case may be, shall be deemed to
                          be rejected by the Company, unless otherwise notified
                          by the Company on the Partner Dashboard.
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          Upon rejection of the invoice as set forth in Clause
                          3.5 and 3.6 above, the Partner shall be notified of
                          the rejection on the Portal.
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          In case of rejection of invoice in terms of Clause 3.6
                          above, the Partner shall forthwith return any Advance
                          money paid by the Company to the Partner. In case of
                          any delay in the return of Advance by the Partner to
                          the Company, the Company reserves the right to charge
                          an interest of 2% per month.
                        </p>
                      </li>
                      <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                        Tax obligations of the Partner
                      </p>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          The Partner shall comply with all the compliance
                          requirements under GST law (as may be amended from
                          time to time). This shall include (but not limited to)
                          the following:
                        </p>
                        <ol className="list-decimal pl-5">
                          <li>
                            <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                              Issuing invoices/ debit notes/ revised invoices/
                              credit notes/Advance Receipt Vouchers as per the
                              prescribed format, containing all the information
                              as is required for the Company to avail input tax
                              credit basis such invoices/ debit notes/ revised
                              invoices;
                            </p>
                          </li>
                          <li>
                            <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                              Delivering invoices to the Company within 2 (two)
                              days from the date of the issuance of the invoice
                              by the Partner either through electronic means or
                              otherwise;
                            </p>
                          </li>
                          <li>
                            <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                              Submitting periodic returns as per the GST laws
                              within specified timelines with complete and
                              correct details as may be prescribed;
                            </p>
                          </li>

                          <li>
                            <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                              Depositing tax within the due dates as may be
                              prescribed;
                            </p>
                          </li>
                          <li>
                            <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                              Issuing payment voucher in all cases where advance
                              is paid by the Company. In case where such advance
                              is refunded without any supply, appropriate refund
                              voucher should be issued by the Partner at the
                              time of receipt of advance or at the time of issue
                              of such refund.
                            </p>
                          </li>
                        </ol>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          If any amount of credit pertaining to the tax invoice
                          issued by the Partner, refund or any other benefit is
                          denied or delayed to the Company or any penal charge
                          is imposed on the Company due to:
                          <ol className="list-decimal pl-5">
                            <li>
                              <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                                any non-compliance by the Partner, including but
                                not limited to failure to upload details of
                                supply on GSTN portal, failure to pay GST to the
                                Government;
                              </p>
                            </li>
                            <li>
                              <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                                non-furnishing or furnishing of incorrect or
                                incomplete documents/ details/ information by
                                the Partner.
                              </p>
                            </li>
                          </ol>
                          <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                            then the Partner shall, at his own cost and effort,
                            get the short comings rectified in the GST return
                            within 30 (thirty) days of communication in writing.
                            In case of failure to do so, the Partner shall be
                            liable to reimburse the loss (including but not
                            limited to input credit, interest and penalty
                            thereon) which accrues to the Company on the
                            aforesaid account. The Company shall be entitled to
                            withhold the payment of all the subsequent invoices
                            issued by the Partner to the extent of credit denied
                            along with interest and penalty thereon. In a
                            situation where there is no payment due by Company
                            to the Partner, the Partner would reimburse the
                            Company any loss incurred and the amount of input
                            credit along with interest within 15 (fifteen) days’
                            time of the communication made by the Company in
                            writing.
                          </p>
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          The Partner shall issue tax invoices as required under
                          the applicable laws, including but not limited to the
                          Central Goods and Service Tax Act, 2017. Further, for
                          advances/ down payments, the Partner shall issue
                          receipt vouchers in accordance with applicable laws,
                          unless otherwise agreed between the Parties.{" "}
                        </p>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <p className=" text-[1rem] mb-2 font-medium">
                      Right to Inspect, Audit and Accounts.
                    </p>
                    <ol className="list-decimal pl-5">
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          The Parties hereby agree that the Company shall have
                          the right, but not an obligation, to carry out a
                          process audit and/or audit to verify the compliance
                          with respect to Clause 13, at the sole cost of the
                          Company.
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          The Parties hereby agree that the Company shall have
                          the right to inspect the premises of the Partner, at
                          any time, during the Term.
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          The Company shall intimate the Partner about
                          conducting such an audit/ inspection, at least five
                          (5) working days in advance.
                        </p>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <p className=" text-[1rem] mb-2 font-medium">
                      Representations and Warranties.
                    </p>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      Each Party hereby represents and warrants to the other
                      that:{" "}
                    </p>
                    <ol className="list-decimal pl-5">
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          It has all full power and authority to execute and
                          deliver this Agreement and to carry out the
                          transactions contemplated hereunder;
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          this Agreement has been duly executed and delivered by
                          the Parties and constitutes a valid and legally
                          binding obligation and is enforceable against each
                          Party in accordance with its terms;
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          all legal/ statutory formalities and approvals (if
                          any) have been completed or obtained for consummation
                          of the transactions contemplated by this Agreement;
                          and
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          this Agreement does not contravene, or constitute a
                          default under, any provision of applicable law,
                          including but not limited to the laws in relation to
                          anti-corruption and anti-bribery, or regulation or of
                          any agreement, judgment, injunction, order, decree or
                          other instrument binding upon each Party.
                        </p>
                      </li>
                    </ol>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      11.2 The Partner hereby represents and warrants to the
                      Company that:
                    </p>
                    <ol className="list-decimal pl-5">
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          it has the necessary skill, experience and resources
                          to carry out its obligations under this Agreement;
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          there are no rights exercisable by or obligations owed
                          to any third party which may prevent or restrict the
                          Partner from fulfilling its obligations under this
                          Agreement during the Term;
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          it shall pass to the Company clean and marketable
                          title to each Product;
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          there are no commencement of bankruptcy, insolvency or
                          similar proceedings, whether voluntary or involuntary,
                          which are pending or has been pending, or is to the
                          knowledge of the Partner, threatened;
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          there are no litigations, actions, claims, disputes or
                          proceedings pending or threatened, which if decided
                          adversely against the Partner would interfere with the
                          performance of this Agreement; and
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          the Products shall be of quality as specified by the
                          Company and free from any defect in material or
                          composition.
                        </p>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <p className=" text-[1rem] mb-2 font-medium">Covenants:</p>
                    <ol className="list-decimal pl-5">
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          The Partner acknowledges and agrees that it shall not,
                          during the Term, supply products, which are same or
                          similar to the Products, to any End Client.
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          The Partner shall be obligated to provide the Company
                          with samples of the Products, as per the requirements
                          and timeline communicated by the Company from time to
                          time.
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          The Partner undertakes to perform its obligations
                          under this Agreement and each applicable Purchase
                          Order, throughout the Term, with all reasonable skill,
                          care and diligence, in a timely and efficient manner,
                          and in accordance with applicable law.
                        </p>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <p className=" text-[1rem] mb-2 font-medium">
                      Compliance with laws:
                    </p>
                    <ol className="list-decimal pl-5">
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          The Partner hereby agrees to be in compliance, at all
                          times during the Term, with all applicable laws in
                          India, including but not limited to labour laws, child
                          labour laws (including but not limited to the
                          Convention No. 138 and 182 of the International Labour
                          Organization), workmen/ employee health and safety
                          laws and laws in relation to human rights protection,
                          environmental protection, anti-corruption and
                          antibribery
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          The Partner shall implement and maintain such
                          policies, as may be necessary to adhere to be in
                          compliance with applicable laws as set forth in Clause
                          19.1.
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          Notwithstanding anything contained herein, any
                          non-compliance by the Partner with the provisions of
                          Clause 19.1 and 19.2 shall be construed as material
                          breach of the Agreement, giving the Company the right
                          to terminate this Agreement in accordance with Clause
                          24, and/or be indemnified in accordance with Clause
                          18.
                        </p>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <p className=" text-[1rem] mb-2 font-medium">
                      Compliance with Legal Metrology Act, 2009 and other
                      applicable laws.
                    </p>
                    <ol className="list-decimal pl-5">
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          The Company shall inform the Partner about the
                          contents and specifications pertaining to the
                          packaging, which are conformant with the Legal
                          Metrology Act, 2009 and other applicable laws and as
                          notified by the End Client(s) to the Company, from
                          time to time, and the Partner shall be responsible to
                          incorporate the same and will not be required to
                          enquire into the correctness or validity of the such
                          details, contents of mandatory panel/ label,
                          specifications provided by the Company.
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          The Partner shall indemnify and keep indemnified the
                          Company and the End Client, its directors, officers
                          and employees harmless from and against, claims,
                          suits, actions and proceedings, liabilities, losses,
                          damages, costs and expenses of any kind (including but
                          not limited to reasonable attorney’s fees) arising
                          from the incorrect contents or specifications
                          incorporated by the Partner leading to non-compliance
                          with Legal Metrology Act, 2009, other applicable laws,
                          and rules formed thereunder.
                        </p>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <p className=" text-[1rem] mb-2 font-medium">
                      Intellectual Property Rights:
                    </p>
                    <ol className="list-decimal pl-5">
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          The Company or the End Client, as the case may be,
                          shall at all times, retain and have sole and exclusive
                          right and title to, ownership of, and interest in any
                          intellectual property, specifications, information,
                          documentation or data, including but not limited to
                          any brand name or trademark, that is provided by the
                          Company to the Partner for the purposes of supply of
                          the Products under this Agreement and under each
                          Purchase Order.
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          Subject to Clause 23, the Company on behalf of itself
                          and the End Client hereby grants limited,
                          non-exclusive and non-assignable right and license to
                          use the Company’s and/or End Client’s name, logo and
                          similar indicia on the Products and packaging thereof,
                          solely for the purpose set out in this Agreement.
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          The Partner shall make prompt written disclosure to
                          the Company of all ideas, inventions, information,
                          improvements, derivatives, discoveries, writings,
                          data, documents, notes, designs, drawings, other
                          materials, and the like made or conceived, or actually
                          or constructively developed, during the Term, whether
                          solely or jointly with others, which refer to, or are
                          suggested by, or result from the supply of the
                          Products pursuant to this Agreement, or from any
                          information provided by the Company or the End Client,
                          and the foregoing shall be assigned to the Company.
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          The provisions of this Clause will survive the expiry
                          or early termination of this Agreement.
                        </p>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <p className=" text-[1rem] mb-2 font-medium">
                      Data Protection
                    </p>
                    <ol className="list-decimal pl-5">
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          The Partner acknowledges that the Company may collect
                          and store and/or the Partner may provide the Company
                          with personal identifiable and sensitive information
                          about the Partner, including without limitation name,
                          phone number, email address, address, postal code,
                          fiscal information, occupation, login details etc.
                          ("Sensitive Information”).
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          Without limiting the applicability of the Privacy
                          Policy, please note that your Information may be used
                          for the following purposes:
                          <ol className="list-decimal pl-5">
                            <li>
                              <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                                to validate, perform and process the obligations
                                of the Company under the Agreement;
                              </p>
                            </li>
                            <li>
                              <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                                to facilitate our internal business operations,
                                including the fulfilment of any legal and
                                regulatory requirements;{" "}
                              </p>
                            </li>
                            <li>
                              <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                                to refer you to third party service providers
                                (including banks and financial institutions) who
                                may propose to offer services to you;
                              </p>
                            </li>
                            <li>
                              <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                                resolve disputes or troubleshoot problems;
                              </p>
                            </li>
                            <li>
                              <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                                detect and protect us against error, fraud and
                                other criminal activity;
                              </p>
                            </li>
                            <li>
                              <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                                enforce the Agreement;{" "}
                              </p>
                            </li>
                            <li>
                              <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                                to analyse, research and innovate on the
                                business of the Company
                              </p>
                            </li>
                          </ol>
                        </p>
                        <li>
                          <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                            Additionally, your Information may be shared with:
                          </p>
                          <ol className="list-decimal pl-5">
                            <li>
                              <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                                affiliates and business partners of the Company;
                              </p>
                            </li>
                            <li>
                              <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                                third parties as part of a corporate transaction
                                such as a merger, business acquisition,
                                investment;
                              </p>
                            </li>
                            <li>
                              <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                                to third parties (including financial
                                institutions or banks) with respect to
                                prospective (i) credit facilities; (ii)
                                services, that may be availed by you.
                              </p>
                            </li>
                          </ol>
                        </li>
                        <li>
                          <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                            In this regard, the Partner acknowledges and
                            consents to the Privacy Policy (available here:
                            https://elchemy.com/privacy-policy), which shall be
                            deemed to be included in this Agreement, setting out
                            the manner in which the Partner’s Sensitive
                            Information is collected, stored, processed, used,
                            transferred and disclosed.
                          </p>
                        </li>
                        <li>
                          <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                            The Partner consents to sharing access to its GST
                            Common Portal in terms of Section 146 of the Central
                            Goods and Services Tax Act, 2017. The Partner
                            authorises the Company to log into its account,
                            access, view, read, extract, store, maintain,
                            capture and transmit the data available on the GST
                            Common Portal.
                          </p>
                        </li>
                        <li>
                          <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                            Upon a request made by the Company, the Partner
                            shall share all details including any electronic
                            verification code or One-time Password (OTP)
                            received by it which are required by the Company to
                            access the Partner’s GST Common Portal. The Partner
                            authorises the Company to use such details to log
                            into the Partner’s GST Common Portal. Once such
                            details are shared by the Partner or its
                            representative, it will be deemed to have been
                            validly given and shared with the Company
                          </p>
                        </li>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <p className=" text-[1rem] mb-2 font-medium">
                      Confidentiality
                    </p>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      The Parties hereby agree that they shall:
                    </p>
                    <ol className="list-decimal pl-5">
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          keep all Confidential Information received from the
                          disclosing Party and shall not, without the prior
                          written consent of the disclosing Party, divulge such
                          Confidential Information to any person or use such
                          Confidential Information other than for the purposes
                          of carrying out this Agreement;
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          take all steps as may be reasonably necessary to
                          protect the integrity of the Confidential Information
                          and to ensure against any unauthorized disclosure
                          thereof;
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          treat all Confidential Information with the same
                          degree of care to avoid disclosure to third parties as
                          is used with respect to the receiving Party’s own
                          confidential information, but not less than a
                          reasonable degree of care;
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          immediately inform the disclosing Party of any
                          potential or accidental disclosure or loss or
                          misappropriation of the Confidential Information and
                          take all steps, together, to retrieve and protect the
                          Confidential Information;
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          acknowledge that the Confidential Information is and
                          will at all times remain the property of the
                          disclosing Party and not use the same for any
                          competitive and/or strategic advantage;
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          return to the disclosing Party all the Confidential
                          Information including but not limited to all notes,
                          copies, translations, conversions, modifications and
                          derivations thereof, upon completion of the need of
                          such Confidential Information or upon the termination
                          of this Agreement; and
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          ensure that each of its personnel or employees who
                          have access to the Confidential Information have
                          agreed to be bound by the same obligations of
                          confidentiality and non-use as apply to the receiving
                          Party under this Agreement
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          The receiving Party agrees that it will not modify,
                          reverse engineer, decompile, create other works from,
                          or disassemble any software programs contained in the
                          Confidential Information without the prior written
                          consent of the disclosing Party.
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          This Agreement shall not restrict the receiving Party
                          from complying with any legal requirement to disclose
                          Confidential Information, provided that the receiving
                          Party shall to the extent that it is not prohibited
                          from doing so by Applicable Law, promptly notify the
                          disclosing Party of such legal requirement so that the
                          disclosing Party may seek to quash such order and to
                          obtain a protective order requiring that the relevant
                          Confidential Information be held in confidence by such
                          court or agency or, if disclosed, be used only for the
                          purposes for which the order was issued. The receiving
                          Party shall cooperate fully with the Company in any
                          such proceeding.
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          The obligations under this Clause shall survive for
                          the period of two (2) years after expiry or early
                          termination of this Agreement and/or for such period
                          as may be prescribed by the law.
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          The Parties acknowledges and understands that any
                          disclosure or misappropriation of any of the
                          Confidential Information in violation of this
                          Agreement may cause irreparable harm to the disclosing
                          Party, the amount of which may be difficult to
                          ascertain. The disclosing Party shall have the right
                          to apply to a court of competent jurisdiction for
                          specific performance and/or an order restraining and
                          enjoining any such further disclosure or breach and
                          for such other relief as the disclosing Party shall
                          deem appropriate. Such right shall be in addition to
                          the remedies otherwise available to the disclosing
                          Party, at law or in equity.
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          For the purposes of this Agreement, “Confidential
                          Information” shall mean the terms of this Agreement,
                          any information, whether written or oral, which
                          relates to business methodologies, systems, technical
                          data, system study reports, system requirements,
                          specifications, designs, drawings, business models,
                          current/ potential customers or partners, or other
                          information in any format belonging to a Party, which
                          may be provided by such Party to the other Party, or
                          which may come to the knowledge of the other Party by
                          virtue of this Agreement, whether or not specifically
                          marked as being confidential in nature and whether
                          provided either in electronic or physical form, that
                          comes to the knowledge of the other Party during the
                          term of this Agreement or any extension thereof;
                          Provided however that, Confidential Information shall
                          not include information which (i) is in the public
                          domain; (ii) at or prior to the time of disclosure was
                          known to either Party through lawful means or through
                          an act of a third party who is free to make such
                          disclosure without breach of any legal obligation;
                          (iii) at or prior to the time of disclosure, was
                          generally available to the public through no act or
                          omission on either Party; or (iv) is developed by
                          either Party independent of any Confidential
                          Information it receives from either Party.
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          Whistle-blower Policy: The Partner is aware of the
                          Whistle-blower policy and Public Grievance mechanism
                          policy of the Company and hereby consents to the same.
                          The Partner further undertakes to adequately sensitize
                          all its employees, partners, officers and directors of
                          such policy. The Partner agrees and gives consent to
                          the Company to undertake adequate investigations into
                          any and all such whistle-blower complaints received by
                          the Company involving the Partner in any way or
                          manner, in accordance with its Whistle-blower policy.
                        </p>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <p className=" text-[1rem] mb-2 font-medium">Indemnity.</p>
                    <ol className="list-decimal pl-5">
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          Partner hereby undertakes to indemnify and keep
                          indemnified the Company, its directors, officers and
                          employees harmless from and against, any and all third
                          party, claims, suits, actions and proceedings,
                          liabilities, losses, damages, costs and expenses,
                          arising directly in connection with the breach and/or
                          omission of any of its obligations or representations
                          specified in this Agreement except to the extent where
                          such loss, damage, cost or expense of any kind
                          (including but not limited to reasonable attorney's
                          fees) is due to any breach of the terms of this
                          Agreement, gross negligence, fraud or willful
                          misconduct of the Partner.
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          The rights and obligations of the Company and its
                          indemnity under this Clause shall survive the expiry
                          or termination of this Agreement.
                        </p>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <p className=" text-[1rem] mb-2 font-medium">
                      Limitation of Liability. .
                    </p>
                    <ol className="list-decimal pl-5">
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          Notwithstanding any other provision of this agreement
                          to the contrary, in no event will either Party be
                          liable for any special, incidental, indirect,
                          collateral, consequential or punitive damages or lost
                          profits suffered by an indemnified Party, however
                          caused and on any theory of liability, in connection
                          with any damages arising hereunder.
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          In no event shall the total liability of any Party
                          arising under this Agreement exceed, on a
                          product-by-product basis, the total price paid by the
                          Company for such Product hereunder; provided, however,
                          that nothing in this Clause shall limit or exclude any
                          damages or claims to the extent arising out of the
                          Partner’s gross negligence, fraud or willful
                          misconduct.
                        </p>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <p className=" text-[1rem] mb-2 font-medium">
                      Non-Competition:
                    </p>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      The Partner agrees and undertakes that during the Term of
                      this Agreement and for a period of two (2) years from the
                      date of expiry or termination hereof, it shall not,
                      directly or indirectly, alone or with others, individually
                      or through or by any corporate or other business entity,
                      undertake any business which is same or similar to the
                      business of the Company or engage with any customer of the
                      Company, including but not limited to the End Client,
                      without the prior written approval of the Company.
                    </p>
                  </li>
                  <li>
                    <p className=" text-[1rem] mb-2 font-medium">
                      Non-Solicitation:
                    </p>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      During the Term of this Agreement, and two (2) years after
                      the termination hereof, the Partner will not recruit or
                      solicit any employees (including but not limited to
                      contract employees), contractors, consultants, vendors of
                      the Company who have left the Company’s employment or
                      contractual engagement within two (2) years of the
                      cessation of such employment or engagement, without the
                      prior written approval of the Company.
                    </p>
                  </li>
                  <li>
                    <p className=" text-[1rem] mb-2 font-medium">
                      Exclusivity:
                    </p>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      It is expressly agreed and acknowledged by the Partner
                      that this engagement by the Company for procurement of
                      Products is on a non-exclusive basis and the Company shall
                      be free to engage any other party for supply of Products
                      or any other product similar to the Products.
                    </p>
                  </li>
                  <li>
                    <p className=" text-[1rem] mb-2 font-medium">Publicity</p>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      The Partner, its employees, agents and any other entity
                      associated with the Partner, shall not use the name,
                      trademark and/or logo of the Company and/or End Client, in
                      any sales or marketing publication or advertisement or
                      promotional material or in any other manner, without the
                      prior written consent of the Company.
                    </p>
                  </li>
                  <li>
                    <p className=" text-[1rem] mb-2 font-medium">
                      Termination and Effects of Termination.{" "}
                    </p>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      This Agreement shall terminate upon the happening of, the
                      earlier of any one of the following events:
                    </p>
                    <ol className="list-decimal pl-5">
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          by mutual agreement of the Parties;
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          a material breach by either Party of any of the terms
                          of this Agreement and if such Party fails to rectify
                          such material breach within thirty (30) calendar days
                          from the date on which such Party receives a notice of
                          breach from the non-breaching Party. In such event,
                          this Agreement will terminate forthwith upon the
                          expiry of the said thirty (30) day period;
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          any Party (i) files a petition in bankruptcy or a
                          petition seeking reorganization, liquidation,
                          administration (if applicable) or similar relief or
                          such petition is filed against it which is not
                          dismissed or stayed within thirty (30) business days,
                          or (ii) is adjudicated bankrupt or insolvent, or (iii)
                          seeks or consents to the appointment of a trustee,
                          receiver, or administrator, or (iv) admits in writing
                          its inability to pay its debts as they become due;
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          any Party and/or any of its directors, employees,
                          agents or associates are found to be involved in any
                          immoral or criminal activity including but not limited
                          to fraud, misrepresentation, and/or breach of trust,
                          excluding any minor traffic violations; or
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          any inquiry/ investigation/ criminal proceedings have
                          been initiated against the other Party pertaining to
                          suspected fraud/ malpractice/ illegal activities,
                          whether in India or in any other country.
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          The Company shall have a right to terminate this
                          Agreement, for convenience and/or without any reason
                          by providing fifteen (15) days’ prior written notice
                          of its intention to do so.
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          Effects of Termination/ Expiration:
                        </p>
                        <ol className="list-decimal pl-5">
                          <li>
                            <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                              Early termination or expiry of this Agreement
                              shall not affect the rights and obligations of the
                              Parties which have accrued prior to termination.
                            </p>
                          </li>
                          <li>
                            <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                              Any provision of this Agreement that contemplates
                              performance or observance subsequent to the
                              termination or the expiration of this Agreement
                              shall survive and continue in full force and
                              effect, including but not limited to the
                              obligation of the Partner to provide full
                              cooperation to the Company till completion of the
                              Shelf Life of each Product.
                            </p>
                          </li>
                          <li>
                            <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                              Upon expiry or earlier termination of this
                              Agreement, the Parties shall return/ transfer to
                              each other all materials, documents, information/
                              data, etc. in the form of paper documents and/or
                              electronic records, collected by them during the
                              Term.
                            </p>
                          </li>
                          <li>
                            <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                              Upon receipt of any notice of termination, both
                              the Parties shall conduct all their respective
                              obligations until the effective date of
                              termination mentioned in such notice in the manner
                              which is consistent with the obligations of the
                              Parties hereunder and does not prejudice the
                              reputation or goodwill of either Party.
                            </p>
                          </li>
                        </ol>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <p className=" text-[1rem] mb-2 font-medium">
                      Governing Law, Jurisdiction and Dispute Resolution.
                    </p>
                    <ol className="list-decimal pl-5">
                      <li>
                        <p className=" text-[1rem] mb-2 font-medium">
                          Governing Law and Jurisdiction:
                        </p>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          This Agreement shall be governed by the laws of India
                          and shall be subject to sole jurisdiction of the
                          courts at Mumbai.
                        </p>
                      </li>
                      <li>
                        <p className=" text-[1rem] mb-2 font-medium">
                          Dispute Resolution:
                        </p>

                        <ol className="list-decimal pl-5">
                          <li>
                            <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                              Any disputes/ differences arising out of or in
                              connection with this Agreement shall be promptly,
                              amicably, and in good faith resolved by the
                              Parties.
                            </p>
                          </li>
                          <li>
                            <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                              In case no amicable resolution is reached within a
                              period of thirty (30) days, or within such
                              extended period as the Parties may agree upon,
                              from the date on which the dispute or difference
                              was notified to the other Party, the dispute/
                              difference shall be settled by arbitration in
                              accordance to the Arbitration and Conciliation
                              Act, 1996. The arbitral tribunal shall consist of
                              a sole arbitrator appointed jointly by the
                              Parties. The seat and venue of arbitration shall
                              be Mumbai, India and the arbitration proceedings
                              shall be conducted in English. Subject to the
                              foregoing, the courts at Mumbai shall have
                              exclusive jurisdiction with respect to any dispute
                              arising under this Agreement.
                            </p>
                          </li>
                          <li>
                            <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                              This Clause 25.2 shall not prejudice a Party’s
                              right to apply, either prior to or during any
                              arbitration, to any court of competent
                              jurisdiction for interim, provisional or
                              conservatory measures, relief or remedies,
                              including but not limited to a temporary
                              restraining order, preliminary injunction or other
                              interim relief, concerning a dispute, if necessary
                              to protect the interests of such Party or to
                              preserve the status quo pending the arbitration
                              proceeding
                            </p>
                          </li>
                          <li>
                            <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                              Any award rendered by the arbitral tribunal will
                              be final and binding upon all Parties. The right
                              to arbitrate disputes under this Agreement shall
                              survive even upon the termination of this
                              Agreement.
                            </p>
                          </li>
                        </ol>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <p className=" text-[1rem] mb-2 font-medium">
                      Force Majeure:
                    </p>
                    <ol className="list-decimal pl-5">
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          Neither Party will be responsible for any delay or
                          failure to comply with the obligations under the
                          Agreement if the delay or failure arises from any
                          cause which is beyond the reasonable control of such
                          Party, including but not limited to any act of God,
                          fire, flood, earthquake, windstorm or other natural
                          disaster, war, invasion, act of foreign enemies,
                          blockade, embargoes, terrorism, hostilities, lockout,
                          strikes, orders or restrictions imposed by government
                          or any other public authority, software malfunction,
                          internet, or telecommunication outage (“Force
                          Majeure”).
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          Any Party claiming restriction on the performance of
                          any of its obligations under this Agreement due to the
                          happening or arising of an event of Force Majeure
                          hereof shall notify the other Party of the happening
                          or arising and the ending or ceasing of such event or
                          circumstance within three (3) days of determining that
                          an event of Force Majeure has occurred. The Party
                          claiming the event of Force Majeure conditions shall,
                          in all instances and to the extent it is capable of
                          doing so, use its best efforts to remove or remedy the
                          cause thereof and minimize the economic damage arising
                          thereof.
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          Either Party may terminate this Agreement after giving
                          the other Party a prior notice of fifteen (15) days in
                          writing if the event of Force Majeure continues for a
                          period of sixty (60) days, in which case neither Party
                          shall have any liability to the other except for those
                          rights and liabilities that accrued prior to the date
                          of termination.
                        </p>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <p className=" text-[1rem] mb-2 font-medium">Notice:</p>
                    <ol className="list-decimal pl-5">
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          Any communication including any consent, approval,
                          report or notice required or permitted by this
                          Agreement shall be in writing and in English. Any
                          communication by the Partner to the Company shall be
                          over the Portal or by email to the designated email
                          address communicated by the Company to the Partner or
                          delivered to the Company at the following address:{" "}
                          <br />
                          <strong>
                            BizinBiz Technologies Pvt Ltd Address:
                          </strong>{" "}
                          3rd Floor, A50, Donear House, Cross Road Number 1, Near V R A
                          Reality Pvt Ltd, Andheri East, Mumbai, Mumbai Suburban, Maharashtra, India
                          400093
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          Any email by the Partner to the Company under this
                          Agreement must be sent from the email address
                          registered by the Partner with the Company on the
                          Portal in terms of Clause 1 of this Agreement. Any
                          communication by the Partner to the Company shall be
                          effective upon receipt.
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          Any communication by the Company to the Partner shall
                          be sent over the Portal or by email or by registered
                          mail or air courier postage prepaid, addressed to the
                          Partner at the address and email id communicated by it
                          to the Company at the time of registration on the
                          Portal in terms of Clause 1 of the Agreement. Such
                          notice shall be deemed received on the day on which it
                          is hand-delivered or on the next business day
                          following the day on which it is deposited with an
                          overnight delivery service or on the day sent over the
                          Portal or by email.
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          In the event that the Partner changes its address it
                          shall, prior to the date of such change, notify the
                          Company in writing on the Portal as well as by email.
                          Thereafter, such new address shall be the address of
                          Partner for the purposes of this Agreement.
                        </p>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <p className=" text-[1rem] mb-2 font-medium">
                      Relationship between the Parties.
                    </p>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      This Agreement is on a principal-to-principal basis
                      between the Parties hereto. This Agreement does not make
                      either Party an employee, agent or legal representatives
                      of the other for any purpose whatsoever. Neither Party is
                      granted any right or authority to assume or to create any
                      obligation or responsibility, express or implied, on
                      behalf of or in the name of the other Party.{" "}
                    </p>
                  </li>
                  <li>
                    <p className=" text-[1rem] mb-2 font-medium">Assignment</p>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      The Partner shall not assign and/or transfer any of its
                      rights and obligations hereunder without the prior written
                      approval of the Company.
                    </p>
                  </li>
                  <li>
                    <p className=" text-[1rem] mb-2 font-medium">
                      Waiver and Non-exclusion of Remedies:
                    </p>
                    <ol className="list-decimal pl-5">
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          A Party’s delay or failure to enforce any provision of
                          this Agreement, or to exercise any right or remedy
                          shall not constitute a waiver of that provision, right
                          or remedy or prevent such Party from enforcing any or
                          all provisions of this Agreement and exercising any
                          rights or remedies in the future.
                        </p>
                      </li>
                      <li>
                        <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                          No remedy conferred by any provision of this Agreement
                          is intended to be exclusive of any other remedy except
                          as expressly provided for in this Agreement and each
                          and every remedy shall be cumulative and shall be in
                          addition to every other remedy given in this Agreement
                          or existing at law or in equity, by statute or
                          otherwise.
                        </p>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <p className=" text-[1rem] mb-2 font-medium">
                      Severability:
                    </p>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      If any provision of this Agreement shall be held to be
                      invalid, illegal or unenforceable, the validity, legality
                      and enforceability of the remaining provisions shall in no
                      way be affected or impaired thereby and shall remain in
                      full force and effect.
                    </p>
                  </li>
                  <li>
                    <p className=" text-[1rem] mb-2 font-medium">Amendments:</p>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      This Agreement is subject to revision and/or amendment at
                      the sole discretion of the Company. The Partner is
                      responsible to check the Portal for the latest version of
                      the Agreement and shall be deemed to accept the version of
                      this Agreement in its entirety as on date of the PO, upon
                      acceptance of any PO by the Partner in terms of this
                      Agreement. No amendment or modification of this Agreement
                      by the Partner and nor waiver of any of the terms or
                      conditions hereof shall be valid or binding unless made in
                      writing, including through the Partner Dashboard. Such
                      duly executed amendment, modification, or waiver shall be
                      deemed to be an integral part of this Agreement.
                    </p>
                  </li>
                  <li>
                    <p className=" text-[1rem] mb-2 font-medium">Survival:</p>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      The Parties hereby agree and acknowledge that those terms
                      and provisions of this Agreement which by their nature and
                      content should be deemed to survive the termination of
                      this Agreement. Notwithstanding anything herein to the
                      contrary, the following provisions shall survive
                      indefinitely (unless otherwise indicated) the termination
                      of this Agreement for any reason: Clause 17 (
                      <em>Confidentiality</em>), Clause 18 (<em>Indemnity</em>),
                      Clause 7 (<em>Effects of Termination/ Expiration</em>),
                      Clause 25 (
                      <em>
                        Governing Law, Jurisdiction and Dispute Resolution
                      </em>
                      ) and this Clause 33 (<em>Survival</em>).
                    </p>
                  </li>
                  <li>
                    <p className=" text-[1rem] mb-2 font-medium">
                      Electronic Record:
                    </p>
                    <p className="text-[0.9rem] mb-6 font-light text-[#666666]">
                      This document is an electronic record in terms of the
                      Information Technology Act, 2000 (“IT Act”) and rules made
                      thereunder as may be applicable, and the amended
                      provisions pertaining to electronic records in various
                      statutes as amended by the IT Act. This electronic record
                      is generated by a computer system and does not require any
                      physical or digital signatures.
                    </p>
                  </li>
                </ol>
                <p className=" text-[1.5rem] mb-6 font-medium uppercase">
                  THE PARTNER HAS READ THESE TERMS AND CONDITIONS AND AGREES TO
                  ALL OF THE PROVISIONS CONTAINED ABOVE{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsAndConditions;
